/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateRequest } from "../../../../Redux/Slices/requests.slice";
import { getRentalRequest } from "../../../../Redux/APIs/rentalsAPI";
import { approveRentalRequest, assignAssets } from "./api";
import { RENTAL_STATUS } from "../../../Rentals/constant";

const LOCAL_DEFAULT_LIMIT = 10;

const Footer = ({ onCancel, currentPage, setCurrentPage }) => {
  const dispatch = useDispatch();

  const { currentRental } = useSelector((state) => state.rentals);
  const { transportDetailStep, rentalAssigning } = useSelector(
    (state) => state.requests,
  );

  // trike vehicle type
  const vehicleType = rentalAssigning?.vehicleType?.toLowerCase();
  const disabledTrike = !rentalAssigning?.trikeId;
  const disabledBatteries = !rentalAssigning?.batteries?.length;

  const refetchRecords = async () => {
    // close the drawer
    onCancel();

    // fetch the request list again
    const response = await dispatch(
      getRentalRequest({
        offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      }),
    );

    // If no records exist for the current page, move to the previous page
    if (!response.payload.result.length && currentPage > 1) {
      const previousPage = currentPage - 1;
      setCurrentPage(previousPage);

      await dispatch(
        getRentalRequest({
          offset: (previousPage - 1) * LOCAL_DEFAULT_LIMIT,
        }),
      );
    }
  };

  const handleAssign = async () => {
    dispatch(updateRequest({ key: "loading", value: true }));

    const { status } = await assignAssets({
      rentalId: currentRental?.id || 0,
      trikeId: rentalAssigning?.trikeId || 0,
      trikeRegistrationNo: rentalAssigning?.trikeRegistrationNo || "",
      batteries: rentalAssigning?.batteries || [],
    });

    // fetch the records again
    if (status === 200) refetchRecords();

    dispatch(updateRequest({ key: "loading", value: false }));

    dispatch(
      updateRequest({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 Rental Request Accepted",
            description: "Rental request was accepted successfully",
          },
        },
      }),
    );
  };

  const handleNext = () => {
    // if vehicle type is ice -> directly call the API
    if (vehicleType === "ice") handleAssign();

    // if vehicle type is ice -> go forward to battery assigning step
    if (vehicleType === "ev")
      dispatch(updateRequest({ key: "transportDetailStep", value: 3 }));
  };

  // this will approve the request and put it in assign trike state (still not accepted)
  const handleApproveRequest = async () => {
    dispatch(updateRequest({ key: "loading", value: true }));

    const { status } = await approveRentalRequest({
      rentalId: currentRental?.id || 0,
    });

    // fetch the records again
    if (status === 200) refetchRecords();

    dispatch(updateRequest({ key: "loading", value: false }));

    dispatch(
      updateRequest({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 Rental Request Approved",
            description: "Rental request was approved successfully",
          },
        },
      }),
    );
  };

  return (
    <div className="absolute z-10 bottom-0 w-full p-6 bg-background-white flex items-center gap-x-3">
      <button
        type="button"
        className="flex-1 flex items-center justify-center py-3 h-[42px] bg-light-grey hover:bg-medium-grey rounded-md"
        onClick={onCancel}
      >
        <p className="font-poppins font-medium text-xs leading-[18px] text-black">
          Close
        </p>
      </button>

      {+currentRental.status === RENTAL_STATUS.PENDING && (
        <button
          type="button"
          className="flex-1 flex items-center justify-center py-3 h-[42px] bg-alert-red hover:bg-alert-red-hover rounded-md"
          onClick={() =>
            dispatch(
              updateRequest({
                key: "rejectModal",
                value: { visible: true, type: "rentals" },
              }),
            )
          }
        >
          <p className="font-poppins font-medium text-xs leading-[18px] text-white">
            Reject
          </p>
        </button>
      )}

      {+currentRental.status === RENTAL_STATUS.PENDING && (
        <button
          type="button"
          className="flex-1 flex items-center justify-center py-3 h-[42px] bg-primary hover:bg-primary-50 rounded-md"
          onClick={handleApproveRequest}
        >
          <p className="font-poppins font-medium text-xs leading-[18px] text-white">
            Accept
          </p>
        </button>
      )}

      {+currentRental.status === RENTAL_STATUS.ASSIGN_TRIKE &&
        transportDetailStep === 2 && (
          <button
            type="button"
            disabled={disabledTrike}
            onClick={handleNext}
            className={`flex-1 flex items-center justify-center py-3 h-[42px] rounded-md ${
              disabledTrike
                ? "cursor-not-allowed bg-primary-50"
                : "bg-primary hover:bg-primary-50"
            }`}
          >
            <p className="font-popins font-medium text-xs leading-[18px] text-white">
              {vehicleType === "ice" ? "Assign and Accept" : "Next"}
            </p>
          </button>
        )}

      {+currentRental.status === RENTAL_STATUS.ASSIGN_TRIKE &&
        transportDetailStep === 3 &&
        vehicleType === "ev" && (
          <button
            type="button"
            disabled={disabledBatteries}
            onClick={handleAssign}
            className={`flex-1 flex items-center justify-center py-3 h-[42px] rounded-md ${
              disabledBatteries
                ? "cursor-not-allowed bg-primary-50"
                : "bg-primary hover:bg-primary-50"
            }`}
          >
            <p className="font-poppins font-medium text-xs leading-[18px] text-white">
              Assign and Accept
            </p>
          </button>
        )}
    </div>
  );
};

export default Footer;
